import React, { useState, useEffect } from 'react';
import { message, Col, Row, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import apiConnect from '../../../config/apiConfig';
import { CustomButton } from '../../utils/Utils';

const ManageMultimedia = () => {
  const [images, setImages] = useState({
    hall_dermo: '',
    hall_medicamentos: '',
    hall_perfumerias: '',
    Hall: '',
    logo: '',
    rounded_logo_expo: '',
    Fair_Entry: ''
  });
  const [files, setFiles] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const titleMap = {
    hall_dermo: 'Hall Dermocosmética',
    hall_medicamentos: 'Hall Medicamentos',
    hall_perfumerias: 'Hall Perfumería',
    Hall: 'Hall',
    logo: 'Logo Ingreso',
    rounded_logo_expo: 'Logo Interno',
    Fair_Entry: 'Video de Bienvenida'
  };

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await apiConnect.get('/multimedia');
        const fetchedImages = response.data.images;
        const updatedImages = { ...images };

        fetchedImages.forEach((image) => {
          const key = image.match(/(hall_dermo|hall_medicamentos|hall_perfumerias|Hall|logo|rounded_logo_expo|Fair_Entry)/)[0];
          updatedImages[key] = `${process.env.REACT_APP_PUBLIC_ASSETS}${image}`;
        });

        setImages(updatedImages);
      } catch (error) {
        console.error('Error fetching images:', error);
        message.error('Error al cargar las imágenes.');
      }
    };

    fetchImages();
  }, []);

  const handleFileChange = (event, type) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!['image/jpeg', 'image/png', 'image/gif', 'video/mp4'].includes(file.type)) {
      message.error('Tipo de archivo no permitido. Solo se permiten imágenes y videos MP4.');
      return;
    }

    if (images[type]?.startsWith('blob:')) {
      URL.revokeObjectURL(images[type]);
    }

    const objectUrl = URL.createObjectURL(file);

    setFiles({ ...files, [type]: file });
    setImages({ ...images, [type]: objectUrl });
  };

  const saveFiles = async () => {
    try {
      setIsLoading(true);
      const formData = new FormData();

      Object.keys(files).forEach((type) => {
        if (files[type]) {
          formData.append(type, files[type]);
        }
      });

      const response = await apiConnect.post('/upload/multimedia', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      console.log(response);
      message.success('Multimedia actualizada con éxito.');
      const updatedImages = { ...images };

      setImages(updatedImages);
      setFiles({});
    } catch (error) {
      console.error('Error uploading files:', error);
      message.error('Error al subir los archivos.');
    } finally {
      setIsLoading(false);
    }
  };

  const styles = {
    imageContainer: { 
      maxWidth: '100%' 
    },
    placeholder: {
      width: '100%',
      height: '200px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      border: '1px dashed #ccc',
    },
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    gifLabel: {
      position: 'absolute',
      top: '10px',
      left: '10px',
      padding: '5px',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      color: 'white',
      borderRadius: '3px',
    },
    multimediaWrapper: {
      position: 'relative',
      cursor: 'pointer',
      overflow: 'hidden',
      border: '1px solid #ccc',
      padding: '10px',
      borderRadius: '4px',
    },
    multimediaHover: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      opacity: 0,
      transition: 'opacity 0.3s ease',
    },
    multimediaHoverVisible: {
      opacity: 1,
    },
    changeButton: {
      color: 'white',
      backgroundColor: '#1890ff',
      border: 'none',
      padding: '10px 20px',
      cursor: 'pointer',
      borderRadius: '4px',
    },
    hiddenInput: {
      display: 'none',
    },
  };

  return (
    <div>
      <h1>Gestionar Multimedia</h1>
      <Row gutter={[24, 24]} style={{ marginRight: 0 }}>
        {Object.keys(images).map((type, index) => (
          <Col key={index} xs={24} sm={12} md={8}>
            <div>
              <h2>{titleMap[type]}</h2>
              <div
                style={styles.multimediaWrapper}
                onMouseEnter={(e) => {
                  e.currentTarget.querySelector('.hover-overlay').style.opacity = 1;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.querySelector('.hover-overlay').style.opacity = 0;
                }}
              >
                {images[type] ? (
                  images[type].endsWith('.mp4') ? (
                    <video src={images[type]} controls style={styles.imageContainer} />
                  ) : images[type].endsWith('.gif') ? (
                    <div style={{ position: 'relative' }}>
                      <img src={images[type]} alt={type} style={styles.imageContainer} />
                      <span style={styles.gifLabel}>GIF</span>
                    </div>
                  ) : (
                    <img src={images[type]} alt={type} style={styles.imageContainer} />
                  )
                ) : (
                  <div style={styles.placeholder}>
                    <span>No hay imagen</span>
                  </div>
                )}
                <div className="hover-overlay" style={styles.multimediaHover}>
                  <label style={styles.changeButton}>
                    Cambiar Multimedia
                    <input
                      type="file"
                      style={styles.hiddenInput}
                      onChange={(event) => handleFileChange(event, type)}
                    />
                  </label>
                </div>
              </div>
            </div>
          </Col>
        ))}
      </Row>

      <div style={{ padding:'1rem' }}>
        <CustomButton
          color="btnOutline"
          content="Guardar cambios"
          onclick={saveFiles}
          disabled={isLoading}
        />
      </div>
      {isLoading && (
        <div style={styles.overlay}>
          <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
        </div>
      )}
    </div>
  );
};

export default ManageMultimedia;
